import { useDatoQuerySubscription } from '@src/hooks/useDatoQuerySubscription';
import { useEffect } from 'react';

import { MY_AUDIO_QUERY } from '../gql/media-gql';

import type { myAudio } from '../types.ts/story';

export const useQueryMyAudio = (
  ids: string[],
): {
  status: string;
  error: any;
  data: { allMyAudios: myAudio[] } | undefined;
} => {
  const { status, error, data } = useDatoQuerySubscription<
    { allMyAudios: myAudio[] },
    { ids: string[] }
  >({
    query: MY_AUDIO_QUERY,
    variables: { ids },
  });
  return { status, error, data };
};

const MyAudioQuerySubscriptionComponent = (props: {
  audioIds: string[];
  onDataReceived: (audios: myAudio[]) => void;
  onError: (error: any) => void;
}) => {
  const { audioIds, onDataReceived, onError } = props;
  const { error, data } = useQueryMyAudio(audioIds);

  useEffect(() => {
    console.log('data', data);
    console.log('error', error);
    if (error) {
      onError(error);
    } else if (data?.allMyAudios?.length) {
      onDataReceived(data.allMyAudios);
    }
  }, [data, error]);

  return <></>;
};

export default MyAudioQuerySubscriptionComponent;
